import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const AvailableReport = styled(Link)`
  min-width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border: 1px var(--gray200) solid;
  border-radius: 8px;
`

export const ReportMetadata = styled.section`
  display: flex;
  flex-direction: column;
`

export const RequestedReport = styled.section`
  min-width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border: 1px var(--gray200) solid;
  border-radius: 8px;
`
